import { Controller } from "@hotwired/stimulus"
import { patchJson, notifySaveFailure } from "../lib/routing_patch"

// Flat sibling of routing_cascade_controller: an app has no per-platform tier
// to cascade into, so only toggle/changeChannel exist — no toggleSection/
// toggleSource/applySectionChannel split.
export default class extends Controller {
  static values = { routesUrl: String, reviewAlertId: String }

  async toggle(event) {
    const input = event.target
    const checked = input.checked
    const row = this.element
    const select = row.querySelector("select")
    row.classList.toggle("source-off", !checked)
    if (select) select.disabled = !checked

    try {
      await this.#patch({ notification_channel_id: input.dataset.channelId, is_enabled: checked })
    } catch {
      input.checked = !checked
      row.classList.toggle("source-off", checked)
      if (select) select.disabled = checked
      notifySaveFailure()
    }
  }

  async changeChannel(event) {
    const select = event.target
    const label = select.selectedOptions[0]?.text || ""

    try {
      const response = await this.#patch({
        notification_channel_id: select.dataset.channelId,
        destination: select.value,
        destination_label: label
      })
      const { style } = await response.json()
      select.classList.toggle("routing-override", style === "override")
      select.classList.toggle("routing-inherited", style !== "override")
    } catch {
      notifySaveFailure()
    }
  }

  #patch(body) {
    return patchJson(this.routesUrlValue, { review_alert_id: this.reviewAlertIdValue, ...body })
  }
}
